module.exports = __webpack_public_path__ + "assets/beschikbaarheid3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documentation/images/beschikbaarheid3.jpg
// module id = 356
// module chunks = 0